import { useState } from 'react';
import { alsoHeldText, formatPct, isCash } from '../utils/portfolio';
import './HoldingItem.css';

/** One row of a profile's portfolio, with expandable reasoning. */
export default function HoldingItem({ holding, color, alsoHeldBy = [] }) {
  const [open, setOpen] = useState(false);
  const hasWhy = Boolean(holding.why);

  return (
    <li className="holding">
      <div className="holding__row">
        <span className="holding__dot" style={{ background: color }} aria-hidden="true" />
        <div className="holding__body">
          <span>
            <b>{holding.label}</b> {holding.ticker && <span className="ticker">{holding.ticker}</span>}
          </span>

          {alsoHeldBy.length > 0 && (
            <span className="holding__cross">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="9" cy="8" r="3.5" />
                <path d="M2.5 20c.6-3.4 3.3-5.5 6.5-5.5s5.9 2.1 6.5 5.5" />
                <circle cx="17" cy="9" r="2.8" />
                <path d="M16.5 14.6c2.6.1 4.6 2 5 5.4" />
              </svg>
              {alsoHeldText(alsoHeldBy)}
            </span>
          )}

          {hasWhy && (
            <button type="button" className="holding__toggle" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
              {open ? 'Hide reasoning' : 'Why I hold this'}
            </button>
          )}
          {!hasWhy && !isCash(holding) && <span className="holding__none">No reasoning shared yet</span>}
        </div>
        <span className="holding__pct tnum">{formatPct(holding.pct)}</span>
      </div>

      {hasWhy && open && (
        <div className="holding__why">
          <p>{holding.why}</p>
        </div>
      )}
    </li>
  );
}
